import { type RefObject, useEffect } from 'react'

export const useClickOutside = (
  refs: RefObject<HTMLElement | null>[],
  onClickOutside: () => void,
  enabled: boolean = true,
) => {
  useEffect(() => {
    if (!enabled) return

    const handler = (e: MouseEvent) => {
      if (refs.some((ref) => ref.current?.contains(e.target as Node))) return
      onClickOutside()
    }

    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [refs, onClickOutside, enabled])
}
